<template>
  <BaseCustomizeMetal componentCode="AU" :useNotReverse="true">
    <template slot="respect" slot-scope="{ text }">
      <div class="text">
        <span v-html="text.split('')[0] || ''"></span>
        <span v-html="text.split('')[1] || ''"></span>
      </div>
    </template>
  </BaseCustomizeMetal>
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAU",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 132px;
    left: 160px;
    @include betweenTableTablePro {
      top: 93px;
      left: 107px;
    }
    @include table {
      top: 77px;
      left: 83px;
    }
    @include phone {
      top: 64px;
      left: 68px;
    }
  }
  .templeName {
    height: 25px;
    width: 134px;
    .textContainer {
      width: 134px;
    }
  }
  .godName {
    width: 187px;
    height: 55px;
    margin: 3px auto;
    .textContainer {
      width: 187px;
    }
  }
  .gift {
    width: 129px;
    height: 16px;
    .textContainer {
      width: 129px;
    }
  }
  .respect {
    .text {
      position: relative;
      span {
        position: absolute;
      }
      span:nth-child(1) {
        left: -15px;
      }
      span:nth-child(2) {
        right: -15px;
      }
    }
  }
}
</style>
